import React from 'react';
import {
    BannerContainer,
    BannerContent,
    BannerText,
    ClearButton
} from './PromoFilterBanner.styled';

const PromoFilterBanner = ({ promoTitle, productCount, onClear }) => {
    return (
        <BannerContainer>
            <BannerContent>
                <BannerText>
                    Mostrando {productCount} {productCount === 1 ? 'producto' : 'productos'} de "{promoTitle}"
                </BannerText>
                <ClearButton onClick={onClear}>
                    Ver todos
                </ClearButton>
            </BannerContent>
        </BannerContainer>
    );
};

export default PromoFilterBanner;
